import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, IconButton, Icon } from '@chakra-ui/react';
import { useRef, useState } from 'react';
import { FaPlus } from '@react-icons/all-files/fa/FaPlus';
import { SectionBlockSelector } from '../SectionBlockSelector';
export const SectionBlockSelectorButton = props => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };
    const handleBlockAdd = (...args) => {
        props.onBlockAdd(...args);
        setIsOpen(false);
    };
    const canClose = useRef(false);
    const handleMouseLeave = () => {
        canClose.current = true;
        setTimeout(() => {
            if (canClose.current) {
                setIsOpen(false);
            }
        }, 1000);
    };
    const handleMouseEnter = () => {
        canClose.current = false;
    };
    return (_jsxs(Flex, { pos: "relative", onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, children: [_jsx(IconButton, { variant: 'field-highlighter-tooltip', ml: 0.5, "aria-label": "Add", onClick: toggleOpen, children: _jsx(Icon, { asChild: true, children: _jsx(FaPlus, {}) }) }), isOpen && (_jsx(Box, { position: "absolute", top: "6", left: "0", zIndex: "popover", p: "2", children: _jsx(SectionBlockSelector, { sectionTitle: "Add block", sectionDescription: "Select the type of block you want to add", blockTypes: props.blocks, onBlockAdd: handleBlockAdd, onlyAdd: props.onlyAdd }) }))] }));
};
